(function () {
  function initMulticolumnSections(scope = document) {
    const sections = [];

    if (
      scope instanceof Element &&
      scope.matches('.multicolumn-section')
    ) {
      sections.push(scope);
    }

    if (
      scope &&
      typeof scope.querySelectorAll === 'function'
    ) {
      sections.push(
        ...scope.querySelectorAll('.multicolumn-section')
      );
    }

    [...new Set(sections)].forEach((section) => {
      /*
       * Evita criar vários observers para a mesma seção.
       */
      if (section.dataset.multicolumnReady === 'true') {
        return;
      }

      const slider = section.querySelector(
        '.swiper--multicolumn'
      );

      if (!slider) return;

      section.dataset.multicolumnReady = 'true';

      let swiperMulticolumn = null;

      const slides = Array.from(
        slider.querySelectorAll(
          '.multicolumn-list__item'
        )
      );

      const nextButton = section.querySelector(
        '.multicolumn-button-next'
      );

      const prevButton = section.querySelector(
        '.multicolumn-button-prev'
      );

      /*
       * Lê EXATAMENTE o valor selecionado
       * em "Colunas visíveis no mobile".
       *
       * 1   = 1
       * 1.5 = 1.5
       * 2   = 2
       * 2.2 = 2.2
       * 2.5 = 2.5
       * 3   = 3
       */
      function getMobileSlidesPerView() {
        const rawValue = getComputedStyle(section)
          .getPropertyValue('--per-row-mobile')
          .trim();

        const value = parseFloat(rawValue);

        if (
          Number.isNaN(value) ||
          value < 1
        ) {
          return 2.2;
        }

        return value;
      }

      /*
       * Atualiza o Swiper sem recriá-lo.
       */
      function updateSlider() {
        if (!swiperMulticolumn) return;

        const slidesPerView =
          getMobileSlidesPerView();

        swiperMulticolumn.params.slidesPerView =
          slidesPerView;

        /*
         * Também atualizamos breakpoint/base caso
         * alguma versão do Swiper reutilize params.
         */
        if (
          swiperMulticolumn.originalParams
        ) {
          swiperMulticolumn.originalParams.slidesPerView =
            slidesPerView;
        }

        swiperMulticolumn.update();
      }

      /*
       * Cria o carrossel.
       */
      function initSlider() {
        if (swiperMulticolumn) {
          updateSlider();
          return;
        }

        slider.classList.add(
          'multicolumn-swiper-wrapper'
        );

        slides.forEach((slide) => {
          slide.classList.add('swiper-slide');
        });

        swiperMulticolumn = new Swiper(slider, {
          loop: false,

          /*
           * Respeita exatamente a configuração.
           */
          slidesPerView:
            getMobileSlidesPerView(),

          /*
           * Espaçamento entre os cards.
           */
          spaceBetween: 8,

          watchOverflow: true,
          watchSlidesProgress: true,

          observer: true,
          observeParents: true,

          navigation: {
            nextEl: nextButton || undefined,
            prevEl: prevButton || undefined
          }
        });

        /*
         * Recalcula depois que o navegador
         * terminar de montar o layout.
         */
        requestAnimationFrame(() => {
          updateSlider();
        });

        setTimeout(() => {
          updateSlider();
        }, 100);
      }

      /*
       * Remove o Swiper quando volta para desktop.
       */
      function destroySlider() {
        if (!swiperMulticolumn) return;

        slider.classList.remove(
          'multicolumn-swiper-wrapper'
        );

        swiperMulticolumn.destroy(
          true,
          true
        );

        swiperMulticolumn = null;

        slides.forEach((slide) => {
          slide.removeAttribute('style');
        });
      }

      /*
       * Decide entre carrossel mobile
       * e grid desktop.
       */
      function updateSliderState() {
        if (section.clientWidth < 990) {
          initSlider();
        } else {
          destroySlider();
        }
      }

      /*
       * Detecta alterações reais de largura.
       */
      const resizeObserver =
        new ResizeObserver(() => {
          updateSliderState();

          if (swiperMulticolumn) {
            updateSlider();
          }
        });

      resizeObserver.observe(section);

      /*
       * Inicialização.
       */
      updateSliderState();
    });
  }

  /*
   * Primeira carga da loja.
   */
  function initialize() {
    initMulticolumnSections(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once: true
      }
    );
  } else {
    initialize();
  }

  /*
   * Quando a Shopify recarrega a seção
   * dentro do Personalizar tema.
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      if (
        event.target.matches?.(
          '.multicolumn-section'
        )
      ) {
        delete event.target.dataset
          .multicolumnReady;
      }

      event.target
        .querySelectorAll?.(
          '.multicolumn-section'
        )
        .forEach((section) => {
          delete section.dataset
            .multicolumnReady;
        });

      initMulticolumnSections(
        event.target
      );
    }
  );
})();